export const LoginPageFormData = () => {

    return {
        requestPasswordFormData :{
            email:""
        },
        verificationFormData :{
            email:"",
            otp:""
        },
        logInFormData :{
            email: "",
            password: ""
        },
        requestPasswordValidationRules:{
            email: { required: true }
        },
        verificationValidationRules:{
            otp: { required: true }
        },
        defaultPages:{
            verificationPage : false,
            logInPage: true,
            requestPasswordPage : false
        }
    }
}
